<template>
  <div class="app-container">
    <!-- <div class="filter-container">
      <el-row type="flex" justify="start">
        <el-button
          size="small"
          class="filter-item"
          type="primary"
          icon="el-icon-plus"
          @click="add"
          >新增文档</el-button
        >
      </el-row>
    </div> -->
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" label="文档名称">
        <template slot-scope="scope">
          {{ scope.row.remark }}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        min-width="230"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button type="warning" @click="edit(scope.row)"> 修改 </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  data() {
    return {
      list: null,
      total: null,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        nickname: '',
        is_forbidden: '',
      },
      exportLoading: false,
      logid: '',
    }
  },
  created() {
    this.getList()
  },
  watch: {
    rejectModalVisible() {
      this.rejectForm = {
        ...this.rejectForm,
        reason: '',
      }
    },
  },
  computed: {
    publish_status() {
      return (val) => {
        switch (val) {
          case 'unpublished':
            return '未发布'
          case 'published':
            return '已发布'
        }
      }
    },
    publish_type() {
      return (val) => {
        switch (val) {
          case 'whitelist':
            return '白名称'
          case 'all_user':
            return '全部用户'
          case 'all_vip':
            return '全部会员'
        }
      }
    },
    type() {
      return (val) => {
        switch (val) {
          case 'system_message':
            return '系统消息'
          case 'system_notice':
            return '系统公告'
          case 'activity_notice':
            return '活动公告'
        }
      }
    },
  },
  methods: {
    del(row) {
      this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/message/del',
            method: 'post',
            data: {
              id: row.id,
            },
          }).then((res) => {
            console.log(res)
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: '操作成功',
              })
              this.getList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    before(row) {
      console.log(row)
      this.logid = row.id
    },
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/doc/list',
        method: 'get',
        params: this.listQuery,
      }).then((response) => {
        console.log(response)

        this.list = response.data
        // this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    edit(val) {
      this.$router.push('/operation/doclistedit?id=' + val.id)
    },
    add(val) {
      this.$router.push('/operation/doclistedit')
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
</style>
